import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useGetCancellationPolicyFeatureFlagDetails = () => {
  const { isScheduleV3FlagEnabled, isLoading } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  return {
    isCancellationPolicyEnabled: isLoading ? false : isScheduleV3FlagEnabled,
    isLoading,
  };
};
